const body = document.querySelector('body');
const lang = document.querySelector('html').getAttribute('lang');

if (!body.classList.contains('template-product-3d') && window.screen.width < 575) {      
  const buttonPage = document.querySelector('.product__cart-functions .add-to-cart');
  const buttonWrapperPage = document.querySelector('.product__cart-functions .flex-buttons');
  const buttonPageBlock = document.querySelector('.product__cart-functions');

  if(buttonPage && buttonPageBlock) {
    const offsetTop = buttonPageBlock.offsetTop + buttonPage.clientHeight + 120;

    document.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;
  
      if (buttonWrapperPage.classList.contains('product__fixed_button')) {
        buttonWrapperPage.classList.remove('product__fixed_button');
      }
  
      if (scrollTop >= offsetTop) { 
        buttonWrapperPage.classList.add('product__fixed_button');
      }        
    });
  }  
}

// custom popup    
window.setTimeout(function() {    
  const mainContent = document.querySelector('.main-content');  
  const body = document.querySelector('body');  
  const html = document.querySelector('html');  
  const pageWrapper = document.querySelector('.page-wrapper');      
  const headerBlocks = document.querySelectorAll('.shopify-section-group-header-group');
  const stickyHeader = document.querySelector('.sticky-header'); 
  
  // vantages popup
  const vantagesItems = document.querySelectorAll('.card.card__popup');
  const vantagesItemPopups = document.querySelectorAll('.popup__vantages');

  showPopup(vantagesItems, vantagesItemPopups);

  // content popup
  const productContentItems = document.querySelectorAll('.toggle--popup .toggle__title');
  const productContentPopups = document.querySelectorAll('.popup__product_content');

  showPopup(productContentItems, productContentPopups);

  // delivery popup
  const productDeliveryItems = document.querySelectorAll('.delivery__btn');
  const productDeliveryPopups = document.querySelectorAll('.popup__delivery');

  showPopup(productDeliveryItems, productDeliveryPopups);

  // product related color popup
  const productRelatedColorItems = document.querySelectorAll('.related-color-list li.related__show_all');
  const productRelatedColorPopups = document.querySelectorAll('.popup__product_related_color');

  showPopup(productRelatedColorItems, productRelatedColorPopups);

  // Обробка configurator__button для збереження позиції скролу
  const configuratorButtons = document.querySelectorAll('.configurator__button');
  
  configuratorButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Зберігаємо позицію скролу перед переходом
      sessionStorage.setItem('scrollPosition', window.scrollY);
    });
  });
  
  // Відновлюємо позицію скролу при поверненні назад
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      // Сторінка була завантажена з кешу (навігація назад)
      const scrollPosition = sessionStorage.getItem('scrollPosition');
      if (scrollPosition) {
        window.scrollTo(0, parseInt(scrollPosition));
        sessionStorage.removeItem('scrollPosition');
      }
    }
  });
  
  // Додаткова обробка для навігації назад
  window.addEventListener('popstate', function(event) {
    const scrollPosition = sessionStorage.getItem('scrollPosition');
    if (scrollPosition) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(scrollPosition));
        sessionStorage.removeItem('scrollPosition');
      }, 100);
    }
  });
  
  function showPopup(buttons, popups) {      
    buttons.forEach(function(item) {
      
      item.addEventListener('click', function() {                
        mainContent.classList.add('content-index');          

        bodyLock();

        if (stickyHeader) {
          stickyHeader.classList.add('hidden')
        }
        
        popups.forEach(popupItem => {              
          const vantagesItemWrapperClose = popupItem.querySelector('.popup__custom .popup__wrapper');
          const vantagesItemClose = popupItem.querySelector('.popup__custom .cros');
          
          if (popupItem.dataset.id === item.id) {
            popupItem.classList.add('popup__active');

            closePopup(vantagesItemWrapperClose, popupItem);
            closePopup(vantagesItemClose, popupItem);
            // Додаємо обробник кліку на сам попап для закриття
            closePopup(popupItem, popupItem);
          }
        });
      })
      
    });
  }

  function closePopup(btn, popups) {
    btn.addEventListener('click', function(e) {
      // Якщо клік на сам попап, перевіряємо, чи клік не на контент всередині
      if (btn === popups && e.target !== popups) {
        return;
      }
      
      mainContent.classList.remove('content-index');          

      if (stickyHeader) {
        stickyHeader.classList.remove('hidden')
      }
      
      if (popups.classList.contains('popup__active')) {
        popups.classList.remove('popup__active');
      }

      body.style.paddingRight = 0;
      body.classList.remove('body__lock');
      
      // Відновлюємо скролл
      body.style.overflow = '';
      html.style.overflow = '';
    })
  }

  function bodyLock() {
    const lockPaddingValue = window.innerWidth - mainContent.offsetWidth + 'px';
    
    body.classList.add('body__lock');
    body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';
    
    if (window.innerWidth > 1024) {
      body.style.paddingRight = lockPaddingValue;
    }
  }
}, 500);

window.setTimeout(function() {
  const reviews = document.querySelector('#judgeme_product_reviews');      
  const reviewsToggleContent = document.querySelector('.toggle.reviews .toggle__content');
  const reviewsLink = document.querySelector('.jdgm-prev-badge');
  const reviewsToggle = document.querySelector('.toggle.reviews');
  const toggleItems = document.querySelectorAll('.toggle.toggle--faq');

  if (reviews && reviewsToggleContent) {
    reviewsToggleContent.append(reviews);        
  }
  
  if (reviewsLink) {
    reviewsLink.addEventListener('click', function() {
      if(reviewsToggle) {
        toggleItems.forEach(function(item) {
          const content = item.querySelector('.toggle__content');
          
          item.classList.remove('opened');
          content.style.display = 'none';
        })
        
        const reviewsContent = reviewsToggle.querySelector('.toggle__content');
        
        reviewsToggle.classList.add('opened');
        reviewsContent.style.display = 'flex';
      }
    });  
  }
}, 500); 

window.setTimeout(function() {
 const shopifyModels = document.querySelector('.shopify-model-viewer-ui');
 const popupModel = document.querySelector('.popup_model');
 const popupModelWindow = document.querySelector('.popup_model_window');
 const popupModelClose = document.querySelector('.popup_model_cros');            
 const btnShow = document.querySelector('.btn_theed_js');
 const body = document.querySelector('body');
 const headerBlocks = document.querySelectorAll('.shopify-section-group-header-group');
 const stickyHeader = document.querySelector('.sticky-header'); 
 
 if (btnShow) {
   btnShow.addEventListener('click', function() {
    popupModelWindow.append(shopifyModels);
    body.classList.add('body_overflow_hidden');
    popupModel.classList.add('popup_model_active');

    if (stickyHeader) {
      stickyHeader.classList.add('hidden')
    }

    headerBlocks.forEach((item) => {
      if (item) {
        item.classList.add('hidden')
      }
    })
  })
 }

 if (popupModelClose) {
    popupModelClose.addEventListener('click', function() {
      body.classList.remove('body_overflow_hidden');
      popupModel.classList.remove('popup_model_active');

      if (stickyHeader) {
        stickyHeader.classList.remove('hidden')
      }

      headerBlocks.forEach((item) => {
        if (item) {
          item.classList.remove('hidden')
        }
      })
    })
 }
}, 1000); 

window.setTimeout(function() {
 const treedMobile = document.querySelector('.btn_theed_mobile');

 if (treedMobile) {
   treedMobile.classList.add('btn_theed_small');
 } 
}, 2500);

// anchor scrool
const anchorLinks = document.querySelectorAll('a.anchor');

anchorLinks.forEach(link => {
  if (link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const topOffset = 40;
      const href = this.getAttribute('href').substring(1);
      const scrollTarget = document.getElementById(href);
      const elementPosition = scrollTarget.getBoundingClientRect().top;
      const offsetPosition = elementPosition - topOffset;

      window.scrollBy({
        top: offsetPosition,
        behavior: 'smooth',
      })
    })
  }
})

// hide title color related block
let elementDrawer = document.querySelector('.hc-color-drawer-label');

if (elementDrawer && elementDrawer.classList.contains('hc-color-drawer-hide')) {
  let prevElementDrawer = elementDrawer.previousElementSibling;

  if (prevElementDrawer && prevElementDrawer.classList.contains('product-variant__name')) {    
    prevElementDrawer.style.display = 'none';
  }
}
// sale product persentage
const variants = document.querySelectorAll('.hc-popup-item');
const productSaleLabels = document.querySelectorAll('.product__sale');
const productPrice = document.querySelector('.product-price--original');
const formProductId = document.querySelector('.product-actions form input[name="id"]');

function showSaleLabel(variantId, variants) {
  productSaleLabels.forEach(function(label) {
    const idVariant = label.dataset.variantId;
    const selectedVariant = label.dataset.variantSelected;
    const priceVariant = label.dataset.price;
    const salePriceVariant = label.dataset.salePrice;
    const persentageBlockVariant = label.querySelector('.product__sale_persentage');
    const persentage = priceVariant / salePriceVariant * 100 - 100;
    const activeSaleLabelPopup = variants > 1 ? variantId : idVariant;

    if (salePriceVariant && idVariant === activeSaleLabelPopup || formProductId.value === idVariant) {
      if (label.classList.contains('product__sale_hide')) {
        label.classList.remove('product__sale_hide');

        if (!productPrice.classList.contains('sale_price')) {
          productPrice.classList.add('sale_price');
        }
      }
    } else {
      label.classList.add('product__sale_hide');

      if (productPrice.classList.contains('sale_price')) {
        productPrice.classList.remove('sale_price');
      }
    }

    persentageBlockVariant.innerHTML = Math.round(persentage);
  })
} 

showSaleLabel('', variants.length);

// delivery variants block
const deliveryDecline = document.querySelectorAll('.delivery_decline');

function delivery(variantId) {
  deliveryDecline.forEach(function(item) {
    const itemVariantActive = item.dataset.variantActive;
    const itemVariantId = item.dataset.variantId;
    const itemActive = variantId ? variantId : itemVariantActive;

    if (itemActive == itemVariantId) {
      if (item.classList.contains('delivery_decline_hide')) {
        item.classList.remove('delivery_decline_hide');
      }
    } else {
      item.classList.add('delivery_decline_hide');
    }     
  })
};  

delivery();  

// sale and delivery variants block listener click
variants.forEach(function(variant) {
  variant.addEventListener('click', function() {
    setTimeout(function() {
      delivery(formProductId.value);
      showSaleLabel(formProductId.value, variants.length);
    }, 100);
  })
})

// tooltip
document.addEventListener('DOMContentLoaded', function() {
  const tooltipContainers = document.querySelectorAll('.tooltip');

  tooltipContainers.forEach(container => {
      const tooltipText = container.getAttribute('data-tooltip');

      const tooltipElement = document.createElement('span');
      tooltipElement.className = 'tooltip-text';
      tooltipElement.innerText = tooltipText;

      container.appendChild(tooltipElement);
  });
});

// qty list
let qtyBlock = document.querySelector('.product-quantity');
let summItem = 100;

if(qtyBlock) {
  let qtySelect = qtyBlock.querySelector('.qty');

  if (qtySelect) {
    for (let i = 6; i <= summItem; i++) {
      const listSelect = document.createElement('option');
      listSelect.textContent = `${i}`;
      listSelect.value = `${i}`;
      qtySelect.appendChild(listSelect);
    }
  }
}

// show popup
const popups_app = document.querySelectorAll('.popup__app_model');

if (popups_app) {
  popups_app.forEach(function(item) {
    const intervalId = setInterval(function() {
      item.style.opacity = 1;    
      clearInterval(intervalId);
    }, 1000)     
  }) 
}

// scroll block options
if (window.innerWidth < 550) {
  document.addEventListener("DOMContentLoaded", function() {
    var referrer = document.referrer;
    var isCollectionPage = referrer.includes("/products/");
  
    if (referrer && isCollectionPage) {
        var targetBlock = document.querySelector(".product__title");
        
      if (targetBlock) {
        targetBlock.scrollIntoView({ behavior: "smooth" });
      }
    }
  });
}

// 3D Angle text (transfer block)
const confContainer = document.querySelector('.tda-app-section-content')
const footerBlock = document.querySelector('.tda-customizer-footer');
const textContainer = document.querySelector('.tda-customizer-controls-container');
const optionsContent = document.querySelector('.tda-customizer-customization-options-container');

if (window.innerWidth > 1024) {
  if (footerBlock && textContainer) {
    textContainer.appendChild(footerBlock);
  }
}

// remove swipper slider
const cleanSwiperSliders = () => {
  document.querySelectorAll('.swiper-wrapper').forEach(wrapper => {
    const parent = wrapper.parentElement;
    const slides = wrapper.querySelectorAll('.swiper-slide');

    slides.forEach(slide => {
      slide.removeAttribute('style');
      slide.classList.remove('swiper-slide', 'swiper-slide-active', 'swiper-slide-next');
      parent.appendChild(slide);
    });

    wrapper.remove();

    if (parent.classList.contains('swiper-container')) {
      parent.classList.remove('swiper-container', 'swiper-container-initialized', 'swiper-container-horizontal');
      parent.removeAttribute('style');
    }

    parent.querySelectorAll('.swiper-button-next, .swiper-button-prev').forEach(nav => nav.remove());
  });
};

cleanSwiperSliders();

const observer = new MutationObserver(() => cleanSwiperSliders());
observer.observe(document.body, { childList: true, subtree: true });

// add title blocks
if (window.innerWidth < 767) {
  const waitForBlocks = setInterval(() => {
    const all = [...document.querySelectorAll('[id^="tda-customizer-customization-option-"]')];
  
    const topLevel = all.filter(el => {
      return !all.some(other => other !== el && other.contains(el));
    });
  
    const labels = [...document.querySelectorAll('div > strong')].map(el => el.textContent.trim()).filter(Boolean);
  
    if (topLevel.length > 0) {
      clearInterval(waitForBlocks);    
  
      topLevel.forEach(function(item, index) {
        let titleBlock = document.createElement('div');
  
        item.classList.add('option__item');
        titleBlock.classList.add('option__item_title');
  
        if (labels[index] == 'Size (Oak/Walhut)' || labels[index] == 'SIZE (OLIVE)') {
          titleBlock.textContent = "Size";
        } else {
          titleBlock.textContent = labels[index];
        }

        const itemSlides = item.querySelectorAll('.option-value-swiper-slide');

        itemSlides.forEach((slide) => {
          const slideOption = slide.querySelector('.tda-customizer-customization-option-value');

          changeClassActive();

          slide.addEventListener('click', () => {
            changeClassActive();
          })            
            
          function changeClassActive() {
            if (slideOption && slideOption.classList.contains('tda-customizer-customization-option-value-selected')) {            
              slide.classList.add('tda-customizer-customization-option-value-selected')
            }
          }
        })

        item.appendChild(titleBlock);      
      })
    }
  }, 500);
}

// transfer title configurator
const confTitle = document.querySelector('.tda-customizer-product-title');
const confOptionContainer = document.querySelector('.tda-customizer-controls-container');

if (confTitle && confOptionContainer) {
  confOptionContainer.appendChild(confTitle);  
}

// 3D Angle text
const leftBlock = document.querySelector('.tda-customizer-footer-left');

// price text
// if (leftBlock) {
//   const priceBlock = leftBlock.querySelector('.tda-customizer-variant-price-container');
//   const price = priceBlock.querySelector('.tda-customizer-variant-price')
//   let priceText = document.createElement('div');

//   price.parentElement.classList.add('price_block');

//   priceText.classList.add('price_text')
//   // priceText.innerHTML = 'Blocca il tuo progetto con €29 – detratto dal prezzo finale del tavolo.';
  
//   priceBlock.appendChild(priceText);

//   // price info
//   let priceInfo = document.createElement('div');

//   priceInfo.classList.add('price_info')
//   // priceInfo.innerHTML = '<span>Prezzo totale del tavolo personalizzato</span>';

//   leftBlock.appendChild(priceInfo);
// }

//right block
const rightBlock = document.querySelector('.tda-customizer-footer-right');
const confPrice = document.querySelector('.tda-customizer-variant-price');

if (rightBlock) {
  const rightBlockBtns = document.querySelector('.tda-customizer-footer-btns');
  let confTextNote = '',
      confTextPrice = '',
      confTextist = '';

  // if (lang == 'de') {
  //   confTextNote = 'Enthält ein vollständiges 3D-Projekt und persönliche Design-Beratung. Kostenlose Lieferung inklusive.';
  //   confTextPrice = 'Unverbindlicher Gesamtpreis <span class="conf_price"></span> (inkl. MwSt.). Der finale Preis wird nach dem 3D-Projekt bestätigt.';
  //   confTextist = `
  //     <span>Das ist enthalten:</span>
  //     <ul>
  //       <li>3D-Modell mit Augmented Reality – sehen Sie Ihren Tisch direkt in Ihrem Zuhause</li>
  //       <li>Realistische Visualisierung Ihres zukünftigen Tisches</li>
  //       <li>Unbegrenzte Designanpassungen</li>
  //       <li>29 € werden beim Kauf gutgeschrieben – das Projekt ist kostenlos, wenn Sie bestellen</li>
  //     </ul>
  //   `
  // } else {
  //   confTextNote = 'Includes a full 3D project and personal design support. Free delivery included.';    
  //   confTextPrice = 'Estimated total: <span class="conf_price"></span> (VAT included). Final price confirmed after your 3D project.';
  //   confTextist = `
  //     <span>What’s included:</span>
  //     <ul>
  //       <li>3D model with Augmented Reality – see your table in your home</li>
  //       <li>Hyper-realistic visualization of your future table</li>
  //       <li>Unlimited design revisions</li>
  //       <li>£26 credited to your table purchase — the project becomes free when you order.</li>
  //     </ul>
  //   `
  // }
  
  let configuratorContentText = document.querySelector('.configurator__content_text'); 
  let configuratorContentShipping = document.querySelector('.configurator__shipping'); 
  let configuratorContentInfo = document.querySelector('.configurator__info');
  let configuratorContentReviews = document.querySelector('.configurator__reviews');
  let configuratorContentBanner = document.querySelector('.configurator__sale');

  // content text
  if (configuratorContentText) {
    addBlockConfigurator(rightBlockBtns, configuratorContentText, 'tda-customizer__text');
  }

  // shipping block
  if (configuratorContentShipping) {
    addBlockConfigurator(rightBlockBtns, configuratorContentShipping, 'tda-customizer__shipping');
  }

  // info block
  if (configuratorContentInfo) {
    addBlockConfigurator(rightBlockBtns, configuratorContentInfo, 'tda-customizer__info');
  }

  // reviews
  if (configuratorContentReviews) {
    addBlockConfigurator(rightBlockBtns, configuratorContentReviews, 'tda-customizer__reviews');
  }

  // banner sale
  if (configuratorContentBanner) {
    addBlockConfigurator(rightBlockBtns, configuratorContentBanner, 'tda-customizer__sale');
  }

  function addBlockConfigurator(parrentBlock, appendBlock, classBlock) {
    let newBlock = document.createElement('div');
    newBlock.classList.add(classBlock);
    newBlock.innerHTML = appendBlock.innerHTML;      
    parrentBlock.appendChild(newBlock);
  } 
}

// customize configurator
const configurator = document.querySelector('.tda-customizer-wrapper');

// hide h1
if (configurator) {
  const headH1 = configurator.querySelector('h1').parentElement;

  headH1.style.display = 'none';
}

// configurator sticky
const waitForElements = setInterval(() => {
  const siteBody = document.querySelector('body');
  const btnBuy = document.querySelector('.tda-add-to-cart-block');
  const variantPrice = document.querySelector('.tda-customizer-variant-price');
  const configuratorContent = document.querySelector('.configurator__content');

  const configurationSticky = configuratorContent?.querySelector('.configurator__content_sticky');
  const configuratorContentPrice = configuratorContent?.querySelector('.configurator__content_price .prices');

  if (btnBuy && variantPrice && configurationSticky && configuratorContentPrice) {
    clearInterval(waitForElements);

    const originalParent = variantPrice.parentElement;

    const movePriceToSticky = () => {
      if (!configuratorContentPrice.contains(variantPrice)) {
        configuratorContentPrice.appendChild(variantPrice);
      }
      configurationSticky.classList.add('content_active');
      siteBody.classList.add('body_chat_active');
    };

    const movePriceBack = () => {
      if (!originalParent.contains(variantPrice)) {
        originalParent.appendChild(variantPrice);
      }
      configurationSticky.classList.remove('content_active');
      siteBody.classList.remove('body_chat_active');
    };

    const checkAndToggleSticky = () => {
      const rect = btnBuy.getBoundingClientRect();
      const inView = rect.bottom > 0 && rect.top < window.innerHeight;

      if (inView) {
        movePriceBack();
      } else {
        movePriceToSticky();
      }
    };

    const waitForPriceContent = setInterval(() => {
      const text = variantPrice.textContent.trim();

      if (text.length > 0) {
        clearInterval(waitForPriceContent);

        checkAndToggleSticky();

        window.addEventListener('scroll', checkAndToggleSticky);
        window.addEventListener('resize', checkAndToggleSticky);
      }
    }, 100);
  }
}, 300);

// configurator info sticky (end)

// deposit product configurator
const customProductForm = document.querySelector('.custom-product-form');
const pdfBlockPopup = document.querySelector('.pdf__block');

if (customProductForm || pdfBlockPopup) {
  const propertiesProductTitles = document.querySelectorAll('.custom-product-form .product_title');
  const propertiesWoodType = document.querySelectorAll('.custom-product-form .product_wood');
  const propertiesEpoxy = document.querySelectorAll('.custom-product-form .product_epoxy');
  const propertiesSize = document.querySelectorAll('.custom-product-form .product_size');
  const propertiesLegs = document.querySelectorAll('.custom-product-form .product_legs');
  const propertiesLegsColor = document.querySelectorAll('.custom-product-form .product_legs_color');
  const propertiesEdge = document.querySelectorAll('.custom-product-form .product_edge');

  // item popup pdf
  const pdfWoodType = document.querySelectorAll('.popup__block .form_wood_type');  
  const pdfResinStyle = document.querySelectorAll('.popup__block .form_resin_style');
  const pdfSize = document.querySelectorAll('.popup__block .form_size');
  const pdfLegDesign = document.querySelectorAll('.popup__block .form_leg_design');
  const pdfLegColor = document.querySelectorAll('.popup__block .form_leg_color');
  const pdfEge = document.querySelectorAll('.popup__block .form_edge');

  const intervalOptions = setInterval(() => {
    const confProductTitle = document.querySelector('.tda-customizer-product-title').textContent;
    const optionsDesktop = document.querySelectorAll('.tda-customizer-customization-option');
    const optionsMobile = document.querySelectorAll('.option__item');
    

    if (optionsDesktop.length > 0 && confProductTitle || optionsMobile.length > 0 && confProductTitle) {
      
      if (window.screen.width < 575) {
        optionSettings('mobile', optionsMobile, '.option__item_title', '.option-value-swiper-slide', '.swiper-option-value-info small', '.tda-customizer-customization-option-value .tda-customizer-customization-option-value-title', '.swiper-selected-option-value-detail');
      } else {
        optionSettings('desktop', optionsDesktop, '.tda-customizer-customization-option-title', '.tda-customizer-customization-option-value', '.tda-tooltiptext span', '.tda-customizer-customization-option-value-title', '.selected-option-value-detail');   
      }

      function optionSettings(device, options, titleClass, optionClass, optionItemRadioClass, optionItemEdgeClass, sizeActiveClass) {
        if(propertiesProductTitles && confProductTitle) {
          propertiesProductTitles.forEach((title) => {
            title.value = confProductTitle;
          })
        }

        options.forEach((option) => {
          const optionTitle = option.querySelector(titleClass).textContent;
          const optionList = option.querySelectorAll(optionClass);

          if (lang == 'de') {
            textWoodType = 'Holzart';
            textResignStyle = 'Harzdesign';
            textLegsDesign = 'Tischgestell';
            textLegColor = 'Gestellfarbe';
            textSize = 'Maße';
            textSizeOak = 'Maße (Eiche/Nussbaum)';
            textSizeOlive = 'MAßE (OLIVE)';
            textEge = 'Kante';
          } else {
            textWoodType = 'Wood type';
            textResignStyle = 'Resin Style';
            textLegsDesign = 'Leg Design';
            textLegColor = 'Leg color';
            textSize = 'Size';
            textSizeOak = 'Size (Oak/Walnut)';
            textSizeOlive = 'SIZE (OLIVE)';
            textEge = 'Edge';
          }
    
          addOptions(textWoodType, 'radio', propertiesWoodType, pdfWoodType);
          addOptions(textResignStyle, 'radio', propertiesEpoxy, pdfResinStyle);
          // addOptions('Epoxy variation', 'radio', propertiesEpoxy);

          if (device == 'mobile') {
            legsMobile('Legs variation', propertiesLegs);
          } else if (device == 'desktop') {
            addOptions('Legs variation', 'radio', propertiesLegs);
          }

          if (device == 'mobile') {
            legsMobile(textLegsDesign, propertiesLegs, pdfLegDesign);
          } else if (device == 'desktop') {
            addOptions(textLegsDesign, 'radio', propertiesLegs, pdfLegDesign);
          }

          addOptions(textLegColor, 'radio', propertiesLegsColor, pdfLegColor);
          addOptions(textEge, 'edge', propertiesEdge, pdfEge);
          addOptionsSize(propertiesSize, pdfSize);
    
          function addOptionsSize(inputBlocks, inputPdf) {
            changeOption();

            if (optionTitle == textWoodType) {
              optionList.forEach((item) => {
                item.addEventListener('click', () => {
                  changeOption();              
                })
              }) 
            }          
            
            function changeOption() {
              options.forEach((optionsItem) => {
                const optionsItemTitle = optionsItem.querySelector(titleClass).textContent;
    
                if (optionsItemTitle == textSizeOak || optionsItemTitle == textSizeOlive || optionsItemTitle == textSize) {              
                  if (optionsItem.style.display != 'none') {
                    changeSelected(optionsItem);
    
                    optionsItem.addEventListener('click', function() {
                      changeSelected(optionsItem)
                    })
    
                    function changeSelected(item) {
                      const optionsItemSelected = item.querySelector(sizeActiveClass).textContent;

                      if (inputBlocks) {
                        inputBlocks.forEach((inputBlock) => {
                          inputBlock.value = optionsItemSelected;
                        })
                      }                      

                      if (inputPdf) {
                        inputPdf.forEach((itemPdf) => {
                          itemPdf.value = optionsItemSelected;                          
                        })
                      }
                    }
                  }
                }
              })
            }        
          }

          function legsMobile(optionName, inputBlocks, inputBlocksPdf) {
            if (optionTitle == optionName) {
              const selectedOption = option.querySelector('.swiper-selected-option-value-detail');
              
              changeOption()

              option.addEventListener('click', () => {
                changeOption()
              })

              function changeOption() {
                inputBlocks.forEach((inputBlock) => {
                  inputBlock.value = selectedOption.textContent;
                })

                if (inputBlocksPdf) {
                  inputBlocksPdf.forEach((inputBlockPdf) => {
                    inputBlockPdf.value = selectedOption.textContent;
                  })
                }
              }              
            }
          }
    
          function addOptions(option, type, inputBlocks, inputPdf) {
            if (inputBlocks && optionTitle == option) {
    
              optionList.forEach((item) => {
                const itemSelectedClass = 'tda-customizer-customization-option-value-selected';

                let itemText = '';
                if (type == 'radio' && item.querySelector(optionItemRadioClass)) {
                  itemText = item.querySelector(optionItemRadioClass).textContent;
                } else if (type == 'edge' && item.querySelector(optionItemEdgeClass)) {
                  itemText = item.querySelector(optionItemEdgeClass).textContent;
                }               

                changeValue(itemText);
        
                item.addEventListener('click', () => {
                  changeValue(itemText);                  
                })
      
                function changeValue(text) { 
                  if(item.classList.contains(itemSelectedClass) && text) {
                    inputBlocks.forEach((inputBlock) => {
                      inputBlock.value = text;
                    }) 

                    if (inputPdf) {
                      inputPdf.forEach((itemPdf) => {
                        itemPdf.value = text;                
                      })
                    }
                  }
                }
              })
            }
          }
    
          clearInterval(intervalOptions);      
        })
      }
    }
  }, 300);
}

// change button add to cart configurator
const confFooterBtn = document.querySelector('.tda-customizer-footer-btns'); 
if (confFooterBtn) {
  const confFooterBtnBuy = document.querySelector('.tda-customizer-footer-atc-btn');
  const customProductPage = document.querySelector('.configurator__form_block .custom_product_page');

  let blockAddToCart = document.createElement('div');

  if (confFooterBtnBuy) {
    confFooterBtnBuy.classList.add('conf_btn_none');
  }

  blockAddToCart.classList.add('tda-add-to-cart-block')

  confFooterBtn.appendChild(blockAddToCart);

  if(confFooterBtn && customProductPage) {
    blockAddToCart.appendChild(customProductPage)
  }
}

// form (start)
const btnSticky = document.querySelector('#add-to-cart-section-form_sticky button[type="submit"]');   
const btnContent = document.querySelector('#add-to-cart-section-form_content button[type="submit"]');

function setupCheckoutButton(button) {
  if (!button) return;

  button.addEventListener('click', function(event) {
    event.preventDefault();

    const form = button.form;
    if (!form) {
      console.error('Form not found for button!');
      return;
    }

    const formData = new FormData(form);

    const payload = {
      id: formData.get('id'),
      quantity: 1,
      properties: {}
    };

    form.querySelectorAll('[name^="properties"]').forEach(input => {
      const propertyName = input.name.replace(/^properties\[|\]$/g, '');
      payload.properties[propertyName] = input.value;
    });

    fetch('/cart/clear.js', {
      method: 'POST'
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Error clearing cart');
      }
      return response.json();
    })
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Error adding product');
      }
      return response.json();
    })
    .then(() => {
      console.log('Cart cleared, product added successfully');
      window.location.href = '/checkout';
    })
    .catch(error => {
      console.error('Error:', error);
    });
  });
}

setupCheckoutButton(btnSticky);
setupCheckoutButton(btnContent);
// form (end)

// multi popup
const popupMultiBlock = document.querySelectorAll('[data-js-popup-block]');

const popupMultiBtns = document.querySelectorAll('[data-js-popup-btn]');
const popupMultiWindow = document.querySelector('[data-js-popup-window]');

popupMultiBtns.forEach((btn) => {
  const popupAttribute = btn.getAttribute('aria-popup');
  const popupMultiWindow = document.querySelector(`[data-js-popup-window][id="${popupAttribute}"]`)
  const popupMultiOverlay = document.querySelector(`[data-js-popup-overlay][id="${popupAttribute}"]`)
  const popupMultiClose = popupMultiWindow.querySelector('.hc-drawer-top span.cros');

  btn.addEventListener('click', (e) => {
    console.log(popupMultiWindow);
    
    e.preventDefault();
    showPopup();
  })

  popupMultiClose.addEventListener('click', (e) => {
    e.preventDefault();
    hidePopup();
  })

  popupMultiOverlay.addEventListener('click', (e) => {
    e.preventDefault();
    hidePopup();
  })

  const showPopup = () => {
    document.querySelector('body').classList.add('hc-drawer-active');      

    if (popupMultiWindow) {        
      popupMultiWindow.classList.add('hc-popup-drawer-active');
    }
    if (popupMultiOverlay) {
      popupMultiOverlay.classList.add('hc-drawer-overlay-active');
    }
  }

  const hidePopup = () => {
    document.querySelector('body').classList.remove('hc-drawer-active');

    if (popupMultiWindow) {
      popupMultiWindow.classList.remove('hc-popup-drawer-active');
    }
    if (popupMultiOverlay) {
      popupMultiOverlay.classList.remove('hc-drawer-overlay-active');
    }
  }
  
})

// choise option products